import defaultTheme from './defaultTheme';
// import constants from '../../constants'
export default {
  ...defaultTheme,
  container: '#e9eef5',
  note: '#1a1f3f',
  divider: '#7b7e96'
};
